import {AxiosPromise} from 'axios';

import {ActionType} from '@typescript/common/actionTypes';
import {WIZARD} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

/**
 * Get current product data
 * @param {number} id - Product id
 * @returns {ActionType<AxiosPromise>} Action
 */
export function getProductWizard(id: number): ActionType<AxiosPromise> {
    return {
        type: WIZARD.GET_PRODUCT_WIZARD,
        payload: instanceGusaBackend({
            method: 'get',
            url: ENDPOINTS.PRODUCT_GET_WIZARD({id}),
        }),
    };
}
